import {isSupportWebp} from '@/utils'
export const handleImg = (
    {
        url = '', // 图片地址
        width = '', // 图片宽度
        height = '', // 图片高度
        format = `${isSupportWebp() ? 'webp' : 'jpg'}`, // 转换格式，设置为true，采用原格式，不做转换
        interlace = 1, // 渐进显示
        quality = 85, // 压缩比
        imageslim = false // 图片瘦身
    } = {},
    transform = false, // 转换像素大小
    baseMethod = false // 基础处理方式
) => {
    // 没有url，直接返回空
    if (!url) return ''

    if (format === true) {
        format = ''
    }
    // 转换尺寸
    const rpx2Px = (px) => (transform ? Math.round(px / 2) : px)
    const INIT_WIDTH = 750
    const INIT_HEIGHT = 500
    const realW = rpx2Px(width)
    const realH = rpx2Px(height)
    const reg_video = /^https?:\/\/(static|mobile|media)\.(shopshopslive|shopshops)\.(com|top).+\.(mp4|flv|m3u8)$/
    const reg_image = /^https?:\/\/(static|mobile|media)\.(shopshopslive|shopshops)\.(com|top).+(\.(jpg|jpeg|gif|png|webp))?$/

    // 忽略该域名下的视频格式
    if (reg_video.test(url)) return url

    // 七牛云图片处理
    if (reg_image.test(url)) {
        // 基础处理方式（只支持大图->小图的转换裁切）
        if (baseMethod) {
            const baseRule = `${url}?imageView2`
            const baseRule_end = () => {
                const commonRule = `/interlace/${interlace}/q/${quality}`
                const rule = format ? `/format/${format}${commonRule}` : commonRule
                if (imageslim) {
                    return `${rule}|imageslim`
                }
                return rule
            }
            const fixedRule = (w, h) => `${baseRule}/1/w/${w}/h/${h}`
            const fixedWidthRule = `${baseRule}/2/w/${realW}`
            const fixedHeightRule = `${baseRule}/2/h/${realH}`

            // 有宽没高
            if (realW && !realH) {
                return `${fixedWidthRule}${baseRule_end()}`
            }
            // 有高没宽
            if (!realW && realH) {
                return `${fixedHeightRule}${baseRule_end()}`
            }
            // 没宽也没高，使用默认值
            if (!realW && !realH) {
                return `${fixedRule(INIT_WIDTH, INIT_HEIGHT)}${baseRule_end()}`
            }
            // 有宽也有高
            return `${fixedRule(realW, realH)}${baseRule_end()}`
        }

        // 高级处理方式（默认方式，支持小图->大图的转换裁切）
        const baseUrl_noFormat = `${url}?imageMogr2/auto-orient/quality/${quality}/interlace/${interlace}`
        const baseUrl_front = format
            ? `${baseUrl_noFormat}/format/${format}/thumbnail/`
            : `${baseUrl_noFormat}/thumbnail/`
        const viewBaseUrl_end = 'r/gravity/Center/crop/'
        const imgLim = () => {
            if (imageslim) return '|imageslim'
            return ''
        }

        // 有宽没高
        if (realW && !realH) {
            return `${baseUrl_front}${realW}x${imgLim()}`
        }
        // 有高没宽
        if (!realW && realH) {
            return `${baseUrl_front}x${realH}${imgLim()}`
        }
        // 没宽也没高，使用默认值
        if (!realW && !realH) {
            return `${baseUrl_front}!${INIT_WIDTH}x${INIT_HEIGHT}${viewBaseUrl_end}${INIT_WIDTH}x${INIT_HEIGHT}${imgLim()}`
        }
        // 有宽也有高
        return `${baseUrl_front}!${realW}x${realH}${viewBaseUrl_end}${realW}x${realH}${imgLim()}`
    }

    // ali-oss图片处理
    const ossBaseUrl_front_fixed = `${url}?x-oss-process=image/resize,m_fill,limit_0,`
    const ossBaseUrl_front = `${url}?x-oss-process=image/resize,m_lfit,limit_0,`
    const ossBaseUrl_noFormat = `/interlace,${interlace}/quality,q_${quality}`
    const ossBaseUrl_end = format ? `/format,${format}${ossBaseUrl_noFormat}` : ossBaseUrl_noFormat

    // 有宽没高
    if (realW && !realH) {
        return `${ossBaseUrl_front}w_${realW}${ossBaseUrl_end}`
    }
    // 有高没宽
    if (!realW && realH) {
        return `${ossBaseUrl_front}h_${realH}${ossBaseUrl_end}`
    }
    // 没宽也没高，使用默认值
    if (!realW && !realH) {
        return `${ossBaseUrl_front_fixed}w_${INIT_WIDTH},h_${INIT_HEIGHT}${ossBaseUrl_end}`
    }
    // 有宽也有高
    return `${ossBaseUrl_front_fixed}w_${realW},h_${realH}${ossBaseUrl_end}`
}
